import { render } from "./ServicegroupsIndex.vue?vue&type=template&id=26d50d0c"
import script from "./ServicegroupsIndex.vue?vue&type=script&lang=js"
export * from "./ServicegroupsIndex.vue?vue&type=script&lang=js"

import exportComponent from "/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__